import { cn } from "@/lib/utils";

/**
 * Subtle "Work in progress" hint for a screen whose backend does not exist yet
 * (founder direction 2026-10-03, design-port ALL-5825): a small,
 * low-contrast chip next to the title. Never a banner or a blocking state, and the
 * screen it sits on shows empty states, never sample data. The copy lives here only.
 * Removing the hint is part of the PR that wires the real API.
 */
export const WIP_HINT_LABEL = "Work in progress";

export function WipHint({ className, label = WIP_HINT_LABEL }: { className?: string; label?: string }) {
  return (
    <span
      data-testid="wip-hint"
      className={cn(
        "inline-flex items-center rounded-full border border-line px-2 py-0.5 text-[11px] font-medium leading-none text-muted",
        className,
      )}
    >
      {label}
    </span>
  );
}

/** Reason shown on a control that needs the missing backend; pair with `disabled`. */
export const WIP_ACTION_HINT = "Available once the backend is connected";
